/*
 * @author BSG <dev@bsgroup.eu>
 * @copyright Better Software Group S.A.
 * @version: 1.0
 */
export const SEARCH_QUERY_MIN_LENGTH = 3;
export const SEARCH_MAX_RESULTS = 60;
export const SEARCH_SORT = "created";
export const MEDIA_TYPE_SEASON = "SEASON";
